import React from 'react';

// Section 7 — Personalized Learning Recommendations.
// Sourced from the existing rule-based recommendation engine (EIP). Not labelled "AI".
const RecommendationList = ({ recommendations }) => {
  const list = (recommendations || []).filter(Boolean);
  if (list.length === 0) {
    return (
      <div className="dxr-card">
        <p className="dxr-muted">No specific recommendations at this time — continue regular timed practice.</p>
      </div>
    );
  }

  return (
    <div className="dxr-card">
      <ol className="dxr-reco-list">
        {list.map((r, i) => (
          <li className="dxr-reco-item" key={i}>
            <span className="dxr-reco-index">{i + 1}</span>
            <span className="dxr-reco-text">{r}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default RecommendationList;
